import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsSort } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { Item, Select } from '@components/basics/forms/inputs/Select';

export function Sort<T extends string>({
  value,
  sortTypes,
  onValueChange,
  parseValue,
  showIcon,
}: {
  value: T;
  sortTypes: readonly T[];
  onValueChange: (sortType: T) => void;
  parseValue: ((sortType: T) => string) | null;
  showIcon: boolean;
}) {
  const options = useMemo(
    () =>
      sortTypes.map(sortType => {
        const parsed = parseValue ? parseValue(sortType) : sortType;

        return (
          <Item
            key={sortType}
            value={sortType}
            className="relative flex h-auto w-full select-none items-center rounded-sm bg-white py-1 text-base-m focus:bg-neutral100 hover:bg-neutral100"
          >
            <div className="flex items-center gap-2">
              {showIcon && <FontAwesomeIcon icon={faBarsSort} />}
              <p className="font-medium">{parsed}</p>
            </div>
          </Item>
        );
      }),
    [showIcon, parseValue, sortTypes],
  );

  return (
    <Select value={value} onValueChange={value => onValueChange(value as T)}>
      {options}
    </Select>
  );
}
